// DS: i4.37
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const Sale = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.52 1.72c.17-.13.44-.25.6-.1.16.14.09.38-.02.56l-3 3.69 2.46 3.07c.17.15.24.38.2.6l-.29 1.27a.62.62 0 0 1-.67.5l-4.7-1.24.34 3.66c0 .77-.85.67-1.2.6a.92.92 0 0 1-.27-.09L2.1 11.78c-.21-.1-.4-.32-.4-.56v-.01c.5-6.5 6.55-8.69 8.16-6.75l3.66-2.74ZM10.2 8.27a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z"
    })));
Sale.displayName = 'Sale';
export default Sale;

//# sourceMappingURL=Sale.js.map